/**
 * Remove itens repetidos por `documentId`, mantendo a primeira ocorrência.
 *
 * SA-1252: `chat_entries` pagina por OFFSET e o socket faz prepend na página 0.
 * Cada mensagem nova desloca a janela, então refetchar as páginas seguintes
 * (resync de reconexão, invalidate, paginação ao rolar) traz de volta o item da
 * borda — balão duplicado e `key` repetida no React. Dedupar no flatten é a
 * única camada que cobre os três gatilhos de uma vez.
 *
 * Itens sem `documentId` são descartados: no cache de chats/entries a chave é
 * também a `key` de render, e sem ela o item não é endereçável.
 */
export function dedupeByDocumentId<T extends { documentId?: string | null }>(
  items: T[]
): T[] {
  const seen = new Set<string>();
  const result: T[] = [];

  for (const item of items) {
    const key = String(item.documentId ?? "");
    if (!key || seen.has(key)) continue;
    seen.add(key);
    result.push(item);
  }

  return result;
}
